module.exports = __webpack_public_path__ + "img/sc-3.6752fe7b.png";